import { Button, Stack, Typography } from '@mui/material';
import AccountBalanceRounded from '@mui/icons-material/AccountBalanceRounded';
import PublicRounded from '@mui/icons-material/PublicRounded';
import { useAuth } from '@/auth';
import { AuthLayout } from '@/layouts/AuthLayout';
import { AuthHeader } from '@/pages/auth/AuthHeader';
import { ALL_INSTITUTIONS } from './institutionChoice';
import { useSession } from './session';

/**
 * After signing in, staff who work at more than one institution pick whose data to look at.
 * They can switch later in the top bar. Admins may also look at every institution at once.
 */
export function InstitutionPickerPage() {
  const { signOut } = useAuth();
  const { institutions, setInstitution, isAdmin, user } = useSession();
  const firstName = user.name?.split(' ')[0];

  return (
    <AuthLayout>
      <AuthHeader
        title={firstName ? `Olá, ${firstName}!` : 'Olá!'}
        subtitle="Escolha a instituição cujos dados você quer ver. Dá para trocar depois, no topo da tela."
      />
      <Stack spacing={1.5}>
        {institutions.map((institution) => (
          <Button
            key={institution.id}
            variant="outlined"
            size="large"
            startIcon={<AccountBalanceRounded />}
            onClick={() => setInstitution(institution.id)}
            sx={{ justifyContent: 'flex-start', py: 1.5 }}
          >
            {institution.name}
          </Button>
        ))}
        {isAdmin && (
          <Button
            variant="outlined"
            size="large"
            startIcon={<PublicRounded />}
            onClick={() => setInstitution(ALL_INSTITUTIONS)}
            sx={{ justifyContent: 'flex-start', py: 1.5 }}
          >
            Todas as instituições
          </Button>
        )}
      </Stack>
      <Typography variant="body2" sx={{ textAlign: 'center', mt: 3 }}>
        <Button size="small" color="inherit" onClick={() => void signOut()}>
          Sair
        </Button>
      </Typography>
    </AuthLayout>
  );
}
